import React from 'react';
import { lastArrivalText, liveAlertsLabel, useLiveAlertsStatus } from '../../lib/liveAlerts';

// BL-177 Step 2g (item 1): "Live alerts: Connected / Reconnecting / Off (using 30-second check)" on Settings > My notifications.
// It is the same state the bell reports in the console ([ia-live-alerts] lines), so a live test shows which path delivered.
export default function LiveAlertsStatus({ monitor }) {
    const snapshot = useLiveAlertsStatus(monitor);
    const detail = lastArrivalText(snapshot);
    const failing = ['changes', 'broadcast'].map((path) => ({ path, ...snapshot.paths[path] })).filter((entry) => entry.error);
    return (
        <p className="text-sm" data-testid="live-alerts-status" data-state={snapshot.state}>
            <span role="status" className="font-semibold">{liveAlertsLabel(snapshot.state)}</span>
            {detail && <span className="block" data-testid="live-alerts-last">{detail}</span>}
            {failing.map((entry) => <span key={entry.path} className="block" data-testid={`live-alerts-error-${entry.path}`}>{entry.path === 'changes' ? 'Row updates' : 'Broadcast'}: {entry.error}</span>)}
        </p>
    );
}
